/* eslint-disable */
import Vue from "vue";
import moment from "moment";
import swal from "sweetalert";
import VueToast from "vue-toast-notification";
import { store } from "@/modules/NFe/storeNfe";
import { filtersStore } from "@/components/FilterFields/filtersStore";
import { store as OSStore } from "@/modules/OS/storeOS";
import { store as SimplificadaStore } from "@/modules/Simplificada/storeSimplificada";
import { priceOptions, quantityOptions } from "@/modules/Application";
import { adminPermissionStore } from "@/adminPermissionStore";
import { clienteInadimplenciaStore } from "@/modules/Application/stores/ClienteInadimplenciaStore";
import { store as StoreVenda } from "@/modules/Vendas/storeVenda";

Vue.use(VueToast, {
  position: "top-right",
  duration: 8000,
});

export default {
  methods: {
    parseValorInadimplencia(value) {
      if (value === null || value === undefined || value === "") return null;
      if (typeof value === "number") return Number.isFinite(value) ? value : null;
      if (typeof value !== "string") return null;

      const valorLimpo = value.replace(/[^\d,.-]/g, "");
      const valorNormalizado = valorLimpo.includes(",")
        ? valorLimpo.replace(/\./g, "").replace(",", ".")
        : valorLimpo;
      const valor = parseFloat(valorNormalizado);
      return Number.isFinite(valor) ? valor : null;
    },
    getValorInadimplenciaCliente(cliente) {
      if (!cliente) return null;

      const candidatos = [
        cliente.valor_inadimplencia,
        cliente.inadimplencia,
        cliente.total_inadimplencia,
        cliente.valor_total_inadimplencia,
        cliente.conta_receber_vencida?.valor_total,
        cliente.conta_receber_vencida?.total,
        cliente.contas_receber_vencidas?.valor_total,
        cliente.contas_receber_vencidas?.total,
      ];

      for (const candidato of candidatos) {
        const valor = this.parseValorInadimplencia(candidato);
        if (valor !== null) return valor;
      }

      return null;
    },
    isClienteComInadimplenciaBloqueada(cliente) {
      if (!cliente) return false;

      const valorInadimplencia = this.getValorInadimplenciaCliente(cliente);
      if (valorInadimplencia === null || valorInadimplencia <= 0) return false;

      if (
        Object.prototype.hasOwnProperty.call(
          cliente,
          "bloqueado_por_inadimplencia"
        )
      ) {
        return Boolean(cliente.bloqueado_por_inadimplencia);
      }

      if (!clienteInadimplenciaStore.bloquearVendaClienteInadimplente) {
        return false;
      }

      const limitePermitido =
        this.parseValorInadimplencia(
          clienteInadimplenciaStore.limiteInadimplenciaPermitida
        ) ?? 0;

      return valorInadimplencia >= limitePermitido;
    },
    bloquearClienteInadimplenteSelecionado(cliente) {
      if (!this.isClienteComInadimplenciaBloqueada(cliente)) return false;

      this.$toast.error(
        "Cliente bloqueado por inadimplência. Verifique com o administrador."
      );
      return true;
    },
    confirmCancel(routeToExit) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar o lançamento em andamento?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {

            if (routeToExit == "ordensServicos") {
              OSStore.formGerais = {};
              OSStore.formObjeto = {};
              OSStore.formProblema = {};
              OSStore.formProduto = {};
              OSStore.formServicos = {};
              OSStore.formPagamentos = {};
              OSStore.formObservacoes = {};
              OSStore.formAnexos = {};
              OSStore.orcamentos = [];
            }


            this.$router.push({ name: routeToExit });
          }
        });
    },
    getAdminPasswordSwalTarget() {
      if (typeof document === "undefined") return undefined;

      const activeModals = document.querySelectorAll(".modal.show");
      const activeModal = activeModals[activeModals.length - 1];

      return activeModal?.querySelector(".modal-content") || activeModal;
    },
    async getRequestAdmin(callBackFunction) {
      if (!adminPermissionStore.requestPermission) {
        callBackFunction();
        return;
      }
      const swalOptions = {
        title: "Informe a senha do Administrador",
        showCancelButton: true,
        confirmButtonText: `Continuar`,
        cancelButtonText: `Cancelar`,
        input: "password",
        allowOutsideClick: false,
        focusConfirm: false,
        keydownListenerCapture: true,
        onOpen: () => {
          const passwordInput = this.$swal.getInput();
          if (passwordInput) passwordInput.focus();
        },
        preConfirm: async (password) => {
          try {
            const { data } = await this.$http.post("/usuario/check-adm", {
              password,
            });
            if (!data.status) {
              return this.$swal.showValidationMessage(data.msg);
            }
            this.$toast.success(data.msg);
            return true;
          } catch (error) {
            const message =
              error?.response?.data?.msg ||
              "Não foi possível validar a senha do administrador.";
            return this.$swal.showValidationMessage(message);
          }
          return false;
        },
      };
      const activeModal = this.getAdminPasswordSwalTarget();

      if (activeModal) {
        swalOptions.target = activeModal;
      }

      const isPermissionGranted = await this.$swal.fire(swalOptions);
      const isCanceled = isPermissionGranted?.isDismissed;
      if (isPermissionGranted && !isCanceled) {
        try {
          callBackFunction();
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getTotaisDashboard() {
      try {
        const { data } = await this.$http.post("/dashboard/totais");
        return data.data;
      } catch (error) {
        return [];
      }
    },
    async getFormasPagamentos() {
      try {
        const { data } = await this.$http.post("/financeiro/formas-pagamento");
        return data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    async getTotaisNfe(dataToSend) {
      try {
        const { data } = await this.$http.post("/nfe/calcular-totais-nfe", {
          dados: dataToSend,
        });
        return data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    fireOnboardToast({ id, title, content, buttonText, nextRouterStep, fowardStep }) {
      const h = this.$createElement;
      const toastId = `onboard-${id}`;
      const $okButton = h(
        "b-button",
        {
          on: {
            click: () => {
              if (!nextRouterStep) {
                this.$bvToast.hide(toastId);
                fowardStep();
                return;
              } else {
                fowardStep();
                this.$bvToast.hide(toastId);
                this.$router.push({ name: nextRouterStep });
              }
            },
          },
        },
        buttonText
      );
      const $closeButton = h(
        "b-button",
        {
          on: {
            click: () => {
              this.$bvToast.hide(toastId);
            },
          },
        },
        buttonText === "Sim" ? "Não" : "Fechar"
      );
      const vNodesMsg = h("p", { class: ["mb-2"] }, content);

      this.$bvToast.toast([vNodesMsg, $okButton, $closeButton], {
        id: toastId,
        title: title,
        toaster: "b-toaster-bottom-right",
        solid: true,
        appendToast: false,
        noAutoHide: true,
        noCloseButton: true,
      });
    },
    async criarNfe(dataToSend, tpNF) {
      try {
        const { data } = await this.$http.post("/nfe/create-nfe", {
          dados: { ...dataToSend, tpNF },
        });
        console.log("Data Sended sucessfully");
        return data.id;
      } catch (error) {
        console.log(error);
        return;
      }
    },
    async transmitirNfeApi(id, sendEmail, printDanfe, generateBoleto) {
      try {
        const response = await this.$http.post("/nfe/transmitter-nfe", {
          id,
          "send-email": sendEmail,
          "print-danfe": printDanfe,
          "generate-boleto": generateBoleto,
        });
        console.log("NFe Transmitida com sucesso");
        return response;
      } catch (error) {
        console.log(error);
        return;
      }
    },
    async gerarPdf(id, imprimirDuplicata) {
      try {
        const pdfUrl = await this.$http.post("/nfe/print-nfe", {
          id,
          impressao_duplicata: imprimirDuplicata,
        });
        return pdfUrl;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    formatarCampo(campoTexto) {
      if (campoTexto.length <= 11) {
        return campoTexto.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
      }
      return campoTexto.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
    },
    getParcelas(stringPagamento) {
      const auxArray = stringPagamento.split("x")[0].split(" ");
      const parcelas = parseInt(auxArray[auxArray.length - 1]);
      return parcelas;
    },
    async getTipoPessoa() {
      try {
        const { data } = await this.$http.post("/sistema/tipo/pessoa");
        return data;
      } catch (error) {
        return [];
      }
    },
    async getClientes(nome) {
      try {
        const { data } = await this.$http.post("/pessoa/nome", {
          nome,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getFornecedores(nome) {
      try {
        const { data } = await this.$http.post("/pessoa/nome-fornecedor", {
          nome,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getTipoEndereco() {
      try {
        const { data } = await this.$http.post("/sistema/tipo/endereco");
        return data;
      } catch (error) {
        return [];
      }
    },
    async getTipoFone() {
      try {
        const { data } = await this.$http.post("/sistema/tipo/fone");
        return data;
      } catch (error) {
        return [];
      }
    },
    async getTipoEmail() {
      try {
        const { data } = await this.$http.post("/sistema/tipo/email");
        return data;
      } catch (error) {
        return [];
      }
    },
    async fetchFinalidades() {
      try {
        const { data } = await this.$http.post("/sistema/get-finalidade-nfe");
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async fetchProdutos(search, typeFilter, id_pessoa, listaSelecionada) {
      try {
        const { data } = await this.$http.post("/produtos/filter-item", {
          filter: search,
          typeFilter,
          ...(id_pessoa && { id_pessoa }),
          ...listaSelecionada && { lista_selecionada: listaSelecionada }
        });
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // Retorna true e exibe mensagem quando lançar/alterar a quantidade de um
    // produto ultrapassa o estoque disponível considerando a reserva condicional
    // (disponível = estoque - quantidade_reservada_condicional). A quantidade
    // total é acumulada entre os itens já lançados do mesmo produto na lista.
    reservaCondicionalUltrapassada(
      produto,
      novaQuantidade,
      itens = [],
      indexEditando = null
    ) {
      const desconsiderarEstoqueCondicional = Boolean(
        StoreVenda?.desconsiderarEstoqueCondicional
      );

      if (desconsiderarEstoqueCondicional) {
        return false;
      } else {
        const reservada =
          parseFloat(produto?.quantidade_reservada_condicional) || 0;

        if (reservada <= 0) {
          return false;
        }

        const estoque =
          parseFloat(
            produto?.quantidade_original ??
              produto?.quantidade_original_combinacao ??
              produto?.quantidade
          ) || 0;

        const disponivel = estoque - reservada;
        const idProduto = produto?.id ?? produto?.id_produto;

        const totalOutrosItens = (itens ?? []).reduce((total, item, idx) => {
          if (idx === indexEditando) return total;

          const itemId =
            item?.product?.id ?? item?.product?.id_produto ?? item?.id;

          if (idProduto && Number(itemId) === Number(idProduto)) {
            return total + (parseFloat(item?.quantity ?? item?.quantidade) || 0);
          }

          return total;
        }, 0);

        const totalDesejado =
          totalOutrosItens + (parseFloat(novaQuantidade) || 0);

        if (totalDesejado > disponivel) {
          this.$toast.warning(
            "Este produto possui quantidades reservadas em condicional e não pode ser lançado na venda."
          );
          return true;
        }

        return false;
      }
    },
    async fetchProdutosGrupo(id_grupo, percentual, fator) {
      try {
        const { data } = await this.$http.post("/produtos/get-produtos-grupo", {
          id_grupo,
          percentual,
          fator,
        });
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async fetchListaPreco(descricao) {
      try {
        const { data } = await this.$http.post("/produtos/get-lista", {
          descricao,
        });
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async fetchGrupo(search) {
      try {
        const { data } = await this.$http.post("/produtos/get-grupo-by-descricao", {
          descricao: search,
        });
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async getCidade(filtro) {
      try {
        const { data } = await this.$http.post("/sistema/cidade", {
          filtro,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getCidadeByUF(cidade, uf) {
      try {
        const { data } = await this.$http.post("/sistema/get-cidade-by-uf", {
          cidade,
          uf,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getCFOPs() {
      try {
        const { data } = await this.$http.post("/sistema/cfop");
        return data;
      } catch (error) {
        return [];
      }
    },
    async getCFOPByCodigo(codigo) {
      const { data } = await this.$http.post("/sistema/cfop-by-codigo", {
        codigo,
      });
      return data;
    },
    async getNaturezaByDescricao(descricao) {
      const { data } = await this.$http.post("/natureza/get-natureza", {
        descricao,
      });
      return data;
    },
    async getTransportadoras(search) {
      const { data } = await this.$http.post("/pessoa/get-transportador", {
        nome: search,
      });
      return data;
    },
    async getFretes() {
      const { data } = await this.$http.post("/sistema/get-tipo-frete");
      return data;
    },
    async getFornecedorByNome(nome) {
      const { data } = await this.$http.post("/pessoa/get-fornecedor-by-name", {
        nome,
      });
      return data;
    },
    async getGrupoByDescricao(descricao) {
      const { data } = await this.$http.post("/produtos/get-grupo-by-descricao", {
        descricao,
      });
      return data;
    },
    async getPerfilTributarioByDescricao(descricao) {
      const { data } = await this.$http.post("/perfil-tributario/by-descricao", {
        descricao,
      });
      return data;
    },
    async getTransportadorByNome(nome) {
      const { data } = await this.$http.post("/pessoa/get-transportador", {
        nome,
      });
      return data;
    },
    async getCstCsosn() {
      try {
        const { data } = await this.$http.post("/sistema/cstcsosn");
        return data;
      } catch (error) {
        return [];
      }
    },
    async getCstCest() {
      try {
        const { data } = await this.$http.post("/sistema/cest");
        return data;
      } catch (error) {
        return [];
      }
    },
    async getCESTByCodigo(codigo) {
      const { data } = await this.$http.post("/sistema/cest-by-codigo", {
        codigo,
      });
      return data;
    },
    async getNCM(codigo) {
      try {
        const { data } = await this.$http.post("/sistema/ncm", { codigo });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getTributacao() {
      try {
        const { data } = await this.$http.post("/tributacao?per_page=150");
        return data.data;
      } catch (error) {
        return [];
      }
    },
    async getTributacaoByDescricao(descricao) {
      const { data } = await this.$http.post("/tributacao/tributacao-by-description", { descricao });
      return data;
    },
    async getPlanoContasFinanceiro(tipo, descricao) {
      try {
        const { data } = await this.$http.post("/financeiro/plano-de-contas", {
          tipo,
          descricao,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getPlanoContas(tipo) {
      try {
        const { data } = await this.$http.post("/financeiro/plano-de-contas", {
          tipo,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getPlanoContasContaReceber(descricao) {
      try {
        const { data } = await this.$http.post("/financeiro/plano-de-contas", {
          tipo: 2,
          descricao,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getPlanoContasContaPagar(descricao) {
      try {
        const { data } = await this.$http.post("/financeiro/plano-de-contas", {
          tipo: 1,
          descricao,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getCep(cep) {
      try {
        const { data } = await this.$http.post("/sistema/consulta-cep", { cep });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getUnidadeMedidas() {
      try {
        const { data } = await this.$http.post("/produtos/lista-un", {
          per_page: 150,
        });
        return data.data;
      } catch (error) {
        return [];
      }
    },
    async getGrupos() {
      try {
        const { data } = await this.$http.post("/produtos/lista-grupo", {
          per_page: 150,
        });
        return data.data;
      } catch (error) {
        return [];
      }
    },
    async getProdutoByDescricao(descricao) {
      const { data } = await this.$http.post("/produtos/filter-item", {
        filter: descricao,
      });
      return data;
    },
    async getCenqByCodigo(codigo) {
      const { data } = await this.$http.post("/sistema/cenq-by-codigo", {
        codigo,
      });
      return data;
    },
    async getCSTIPIByCodigo(codigo) {
      const { data } = await this.$http.post("/sistema/cst-ipi-by-codigo", {
        codigo,
      });
      return data;
    },
    async getCSTPISByCodigo(codigo) {
      const { data } = await this.$http.post("/sistema/cst-pis-by-codigo", {
        codigo,
      });
      return data;
    },
    async getAnpByCodigo(codigo) {
      const { data } = await this.$http.post("/sistema/anp-by-codigo", {
        codigo,
      });
      return data;
    },
    async getUF() {
      const { data } = await this.$http.post("/sistema/get-uf");
      return data;
    },
    async getAssinaturaByClient() {
      const { data } = await this.$http.post("/empresa/assinatura");
      return data;
    },
    async getConfigAssinaturasRevenda() {
      const { data } = await this.$http.post("/empresa/assinaturas-revenda");
      return data;
    },
    async getDadosRevenda(id) {
      const { data } = await this.$http.post("/empresa/get-cliente", {
        id_empresa: id,
      });
      return data;
    },
    async getClientesByRevenda(id) {
      const { data } = await this.$http.post("/empresa/lista-clientes", {
        id_revenda: id,
      });
      return data;
    },
    async getListaMCC(description) {
      const { data } = await this.$http.post("sistema/listar-ramos", {
        description,
      });
      return data;
    },
    async getBancosByEmpresa() {
      const { data } = await this.$http.post("/bancos/listar-contas");
      return data;
    },
    async getNutsDigital() {
      const { data } = await this.$http.post("/bancos/find-digital");
      return data;
    },
    async getTiposFrete() {
      const { data } = await this.$http.post("/sistema/get-tipo-frete");
      return data;
    },
    async getUNByDescricao(nome) {
      const { data } = await this.$http.post("/produtos/get-unidade-medida", {
        nome,
      });
      return data;
    },
    async getVendedorByNome(nome) {
      const { data } = await this.$http.post("/vendedor/get-vendedor", {
        nome,
      });
      return data;
    },
    async getPlans() {
      const { data } = await this.$http.post("/empresa/get-plans");
      return data;
    },
    async getTecnicos(search) {
      try {
        const { data } = await this.$http.post("/tecnico/get-tecnico", {
          search,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getObjeto(search) {
      try {
        const { data } = await this.$http.post("/objeto/get-objeto", {
          search,
        });
        return data;
      } catch (error) {
        return [];
      }
    },
    async getPaises() {
      const { data } = await this.$http.post("/nfe/get-paises");
      return data;
    },
    async getModelosPos() {
      try {
        const { data } = await this.$http.post("/pos/modelos");
        return data;
      } catch (error) {
        return [];
      }
    },
    statusLabel(status) {
      switch (status) {
        case 1:
          return "Em processamento";
        case 2:
          return "Enviando";
        case 3:
          return "Cancelada";
        case 4:
          return "Autorizada";
        case 5:
          return "Erro na transmissão";
        case 8:
          return "Rejeitada";
        case 14:
          return "Inutilizada";
        case 15:
          return "Denegada";
        case null:
          return "Editando";
        default:
          return "";
      }
    },
    statusPedidoLabel(status) {
      switch (status) {
        case 1:
          return "Editando";
        case 3:
          return "Autorizado";
        case 4:
          return "Cancelado";
        case 5:
          return "Exportado";
        case 8:
          return "Importado NFe";
        case 9:
          return "Produção";
        case 10:
          return "Entregue/Concluído";
        case 12:
          return "Faturado";
        case 13:
          return "Aprovado";
        case 14:
          return "Aguardando Aprovação";
        case null:
          return "Editando";
        default:
          return "";
      }
    },
    statusMdfeLabel(status) {
      switch (status) {
        case 1:
          return "Editando";
        case 2:
          return "Autorizado";
        case 3:
          return "Cancelado";
        case 4:
          return "Encerrado";
        case 5:
          return "Em processamento";
        case 6:
          return "Rejeitado";
        case 7:
          return "Erro transmissão";
        case 631:
          return "Rejeição duplicidade evento";
        case 203:
          return "Emissor não habilitado";
        case null:
          return "";
        default:
          return "";
      }
    },
    statusOSLabel(status) {
      switch (status) {
        case 1:
          return "Aberta";
        case 2:
          return "Orçada";
        case 3:
          return "Autorizado";
        case 4:
          return "Cancelada";
        case 5:
          return "Exportada";
        case 6:
          return "Não autorizada";
        case 7:
          return "Análise cliente";
        case 8:
          return "Andamento";
        case 9:
          return "Finalizada";
        case 10:
          return "Aguardando componentes";
        case 11:
          return "Serviço concluído";
        case 12:
          return "Finalizada sem concerto";
        case 13:
          return "Pago";
        case 14:
          return "Faturada";
        case 15:
          return "Aguardando cliente";
        case 16:
          return "Garantia da loja";
        case 17:
          return "Aprovado";
        case 18:
          return "Sem defeito";
        case 19:
          return "Entregue agu. faturamento";
        case null:
          return "Editando";
        default:
          return "";
      }
    },
    statusLabelPessoa(status) {
      return status === "A" ? "Ativo" : "Inativo";
    },
    formatFones(fones) {
      var foneFormatado = "";
      fones.forEach((fone, key) => {
        foneFormatado += fone.fone;

        if (fones.length > 1) {
          foneFormatado += ", ";
        }
      });

      return foneFormatado;
    },
    formatEndereco(endereco) {
      var enderecoFormatado = "";
      var complemento = "";
      endereco.forEach((end, key) => {
        if (!end.cep) {
          return null;
        }

        if (end.complemento) {
          complemento = " - Comple: " + end.complemento;
        }

        enderecoFormatado +=
          end.logradouro +
          " - N: " +
          end.numero +
          " - Bairro: " +
          end.bairro +
          complemento +
          " - CEP: " +
          end.cep +
          " - " +
          end.cidade.cidade +
          "/" +
          end.cidade.uf;
      });

      return enderecoFormatado;
    },
    formatNomeFornecedor(fornecedor) {
      if (!fornecedor) return "-";

      var forne = JSON.parse(fornecedor);

      if (!forne) return;

      return forne.nome;
    },
    formatNomeVendedor(vendedor) {
      if (!vendedor) return "-";

      return vendedor.nome;
    },
    formaPordutoProducao(produto) {
      if (!produto) return "-";

      if (!produto) return;

      return produto.codigo + "- " + produto.descricao;
    },
    statusMonitorLabel(status) {
      switch (status) {
        case 1:
          return "Não autorizado";
        case 2:
          return "Manifestada";
        case 3:
          return "Ciencia da emissão";
        case 4:
          return "Confirmação operação";
        case 5:
          return "Desconhecimento operação";
        case 6:
          return "Operação não realizada";
        case 7:
          return "Sem status";
        case 8:
          return "Autorizada";
        default:
          return "";
      }
    },
    statusMonitorClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-primary";
        case 2:
          return "label label-lg label-inline label-light-success";
        case 3:
          return "label label-lg label-inline label-light-danger";
        case 4:
          return "label label-lg label-inline label-light-success";
        case 5:
          return "label label-lg label-inline label-light-danger";
        case 6:
          return "label label-lg label-inline label-light-danger";
        case 7:
          return "label label-lg label-inline label-light-warning";
        case 8:
          return "label label-lg label-inline label-light-primary";
        default:
          return "label label-lg label-inline label-light-warning";
      }
    },
    statusPedidoClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-warning";
        case 3:
          return "label label-lg label-inline label-light-success";
        case 4:
          return "label label-lg label-inline label-light-danger";
        case 5:
          return "label label-lg label-inline label-light-primary";
        case 8:
          return "label label-lg label-inline label-light-primary";
        case 9:
          return "label label-lg label-inline label-light-warning";
        case 10:
          return "label label-lg label-inline label-light-success";
        case 12:
          return "label label-lg label-inline label-light-success";
        case 13:
          return "label label-lg label-inline label-light-primary";
        case 14:
          return "label label-lg label-inline label-light-warning";
        default:
          return "label label-lg label-inline label-light-warning";
      }
    },
    statusOrdemCompraLabel(status) {
      switch (status) {
        case 1:
          return "Aberta";
        case 2:
          return "Em Andamento";
        case 3:
          return "Cancelado";
        case 4:
          return "Atendida";
        case 5:
          return "Encaminhada";
        default:
          return "";
      }
    },
    statusContratosServicosLabel(status) {
      switch (status) {
        case 1:
          return "Editando";
        case 2:
          return "Finalizado";
        case 3:
          return "Cancelado";
        case 4:
          return "Faturado";
        default:
          return "Editando";
      }
    },
    statusContratosServicosClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-primary";
        case 2:
          return "label label-lg label-inline label-light-primary";
        case 3:
          return "label label-lg label-inline label-light-danger";
        case 4:
          return "label label-lg label-inline label-light-success";
        default:
          return "label label-lg label-inline label-light-warning";
      }
    },
    statusOrdemCompraClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-primary";
        case 2:
          return "label label-lg label-inline label-light-primary";
        case 3:
          return "label label-lg label-inline label-light-danger";
        case 4:
          return "label label-lg label-inline label-light-success";
        case 5:
          return "label label-lg label-inline label-light-warning";
        default:
          return "label label-lg label-inline label-light-warning";
      }
    },
    statusMdfeClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-warning";
        case 2:
          return "label label-lg label-inline label-light-success";
        case 3:
          return "label label-lg label-inline label-light-danger";
        case 4:
          return "label label-lg label-inline label-light-info";
        case 5:
          return "label label-lg label-inline label-light-primary";
        case 6:
          return "label label-lg label-inline label-light-danger";
        case 7:
          return "label label-lg label-inline label-light-danger";
        case 631:
          return "label label-lg label-inline label-light-danger";
        case 203:
          return "label label-lg label-inline label-light-danger";
        case null:
          return "";
        default:
          return "";
      }
    },
    statusClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-primary";
        case 2:
          return "label label-lg label-inline label-light-warning";
        case 3:
          return "label label-lg label-inline label-light-danger";
        case 4:
          return "label label-lg label-inline label-light-success";
        case 5:
          return "label label-lg label-inline label-light-danger";
        case 8:
          return "label label-lg label-inline label-light-danger";
        case 14:
          return "label label-lg label-inline label-light-warning";
        case null:
          return "label label-lg label-inline label-light-primary";
        default:
          return "label label-lg label-inline label-light-warning";
      }
    },
    statusProducaoClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-warning";
        case 2:
          return "label label-lg label-inline label-light-info";
        case 3:
          return "label label-lg label-inline label-light-danger";
        case 4:
          return "label label-lg label-inline label-light-warning";
        case 5:
          return "label label-lg label-inline label-light-success";
        case 6:
          return "label label-lg label-inline label-light-success";
        case null:
          return "Editando";
        default:
          return "";
      }
    },
    statusOSClass(status) {
      switch (status) {
        case 1:
          return "label label-lg label-inline label-light-info";
        case 2:
          return "label label-lg label-inline label-light-warning";
        case 3:
          return "label label-lg label-inline label-light-success";
        case 4:
          return "label label-lg label-inline label-light-danger";
        case 5:
          return "label label-lg label-inline label-light-success";
        case 6:
          return "label label-lg label-inline label-light-danger";
        case 7:
          return "label label-lg label-inline label-light-warning";
        case 8:
          return "label label-lg label-inline label-light-warning";
        case 9:
          return "label label-lg label-inline label-light-success";
        case 10:
          return "label label-lg label-inline label-light-warning";
        case 11:
          return "label label-lg label-inline label-light-success";
        case 12:
          return "label label-lg label-inline label-light-info";
        case 13:
          return "label label-lg label-inline label-light-success";
        case 14:
          return "label label-lg label-inline label-light-success";
        case 15:
          return "label label-lg label-inline label-light-warning";
        case 16:
          return "label label-lg label-inline label-light-warning";
        case 17:
          return "label label-lg label-inline label-light-success";
        case 18:
          return "label label-lg label-inline label-light-warning";
        case 19:
          return "label label-lg label-inline label-light-warning";
        case null:
          return "Editando";
        default:
          return "";
      }
    },
    statusNFseLabel(status) {
      switch (status) {
        case 1:
          return "EDITANDO";
        case 2:
          return "PROCESSANDO";
        case 3:
          return "AUTORIZADA";
        case 4:
          return "CANCELADA";
        case 5:
          return "REJEITADA";
        default:
          return "";
      }
    },
    statusProducaoLabel(status) {
      switch (status) {
        case 1:
          return "Não iniciado";
        case 2:
          return "Em produção";
        case 3:
          return "Atrasado";
        case 4:
          return "Pausado";
        case 5:
          return "Entrega Parcial";
        case 6:
          return "Finalizado";
        default:
          return "";
      }
    },
    statusNFseClass(status) {
      switch (status) {
        case 2:
          return "label label-lg label-inline label-light-primary";
        case 1:
          return "label label-lg label-inline label-light-warning";
        case 3:
          return "label label-lg label-inline label-light-success";
        case 4:
          return "label label-lg label-inline label-light-danger";
        case 5:
          return "label label-lg label-inline label-light-danger";
        default:
          return "label label-lg label-inline label-light-warning";
      }
    },
    modeloPos(modelo) {
      switch (modelo) {
        case 1:
          return "Rede";
        case 2:
          return "Stone";
        case 3:
          return "Safra";
        case 4:
          return "Cielo";
        case 5:
          return "Fiserv";
        case 6:
          return "Vero";
        case 7:
          return "GetNet";
        case 8:
          return "Adiq";
        case 9:
          return "PagSeguro";
        case 10:
          return "Elgin";
        case 11:
          return "Punto";
        case 12:
          return "Caixa";
        case 13:
          return "Sicredi";
        default:
          return "";
      }
    },
    convertHexToRGBA(hexCode, opacity = 1) {
      let hex = hexCode.replace("#", "");

      if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
      }

      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      /* Backward compatibility for whole number based opacity values. */
      if (opacity > 1 && opacity <= 100) {
        opacity = opacity / 100;
      }
      return `rgba(${r},${g},${b},${opacity})`;
    },
    // vencimento > hj
    statusByDate(dataItem) {
      if (dataItem.unidade_medida !== undefined) {
        return dataItem.ativo ? "Ativo" : "Inativo";
      }
      if (dataItem.data_recebimento !== undefined) {
        if (dataItem.data_vencimento < this.thisDate() && dataItem.data_recebimento === null) {
          return "Vencida";
        }
        if (dataItem.data_vencimento > this.thisDate() && dataItem.data_recebimento === null) {
          return "A receber";
        }
        if (dataItem.data_recebimento !== null) {
          return "Recebida";
        }
      } else {
        if (dataItem.data_vencimento < this.thisDate() && dataItem.data_pagamento === null) {
          return "Atrasada";
        }
        if (dataItem.data_vencimento > this.thisDate() && dataItem.data_pagamento === null) {
          return "Pendente";
        }
        if (dataItem.pago == true) {
          return "Paga";
        }
      }
      return "";
    },
    async getFinalidadeSintegra() {
      const { data } = await this.$http.post("/relatorios/finalidade-sintegra");
      return data;
    },
    async getRegistrosSintegra() {
      const { data } = await this.$http.post("/relatorios/registros-sintegra");
      return data;
    },
    async getTipoInventarioSintegra() {
      const { data } = await this.$http.post("/relatorios/tipo-inventario-sintegra");
      return data;
    },
    async getBancoZoopByCode(code) {
      const { data } = await this.$http.post("/bancos/lista", {
        code,
      });
      return data;
    },
    async getMenus() {
      const { data } = await this.$http.post("/sistema/menus");
      return data;
    },
    async getCSTCofinsByCodigo(codigo) {
      const { data } = await this.$http.post("/sistema/cst-cofins-by-codigo", {
        codigo,
      });
      return data;
    },
    async getConsultaReceita(cnpj) {
      const { data } = await this.$http.post("/pessoa/receita-dados", {
        cnpj_cpf: cnpj,
      });
      return data;
    },
    async getConsultaCPF(cpf) {
      const { data } = await this.$http.post("/pessoa/consulta-nuts", {
        cpf: cpf,
      });

      return data;
    },
    async getAniversariantes() {
      const { data } = await this.$http.post("/pessoa/aniversariantes", {
        dia: moment().format("YYYY-MM-DD"),
      });

      return data;
    },
    numberToReal(valor, casas) {
      var positivo = true;
      var sifrao = false;
      const casasDecimais =
        typeof casas === "number" ? casas : casas === "quantidade" ? quantityOptions.precision : priceOptions.precision;
      if (valor) {
        if (valor < 0) {
          positivo = false;
          valor = valor * -1;
        }

        var numero = parseFloat(valor);
        numero = numero.toFixed(casasDecimais).split(".");

        if (sifrao) {
          numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join(".");
        } else {
          numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".");
        }

        if (positivo == false) {
          return "-" + numero.join(",");
        }

        return numero.join(",");
      }
      return casasDecimais === 2 ? "0,00" : casasDecimais === 3 ? "0,000" : "0,0000";
    },
    formatDate(value, fmt = "DD/MM/YYYY ") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    thisDateDashboard() {
      return moment().format("DD/MM/YYYY");
    },
    thisDate() {
      return moment().format("YYYY-MM-DD");
    },
    afterYear() {
      return moment().add(1, "year").format("YYYY-MM-DD");
    },
    thisTime() {
      return moment().format("HH:mm:ss");
    },
    addLoadingToButton(ref) {
      const submitButton = this.$refs[ref];

      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      submitButton.setAttribute("disabled", "");
    },
    formatNumberToFloat(numberString) {
      if (typeof numberString === "number") return numberString;

      const partes = numberString.split(/[,.]/);
      let decimalExtension = 0;
      if (partes.length > 1) {
        const casasDecimais = partes[partes.length - 1];
        decimalExtension = casasDecimais.length;
      }

      const valorNumerico = parseFloat(numberString.replaceAll(",", "").replaceAll(".", ""));

      const valueFormatted = valorNumerico / 10 ** decimalExtension;

      return valueFormatted;
    },
    getCurrentWeekData(moduleName) {
      const currentDate = moment();

      const weekStart = currentDate.clone().startOf("isoWeek").format("YYYY-MM-DD");
      const weekEnd = currentDate.clone().endOf("isoWeek").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data_vencimento: [weekStart, weekEnd],
      };
    },

    getCurrentWeekDataFinanceiro(moduleName) {
      const currentDate = moment();

      const weekStart = currentDate.clone().startOf("isoWeek").format("YYYY-MM-DD");
      const weekEnd = currentDate.clone().endOf("isoWeek").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data: [weekStart, weekEnd],
      };
    },

    getCurrentDayData(moduleName) {
      const currentDate = moment().format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data_vencimento: [currentDate],
      };
    },

    getCurrentDayDataFinanceiro(moduleName) {
      const currentDate = moment().format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data: [currentDate],
      };
    },

    getYesterdayDataFinanceiro(moduleName) {
      const currentDate = moment().subtract(1, "days").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data: [currentDate],
      };
    },

    getYesterdayData(moduleName) {
      const currentDate = moment().subtract(1, "days").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data_vencimento: [currentDate],
      };
    },
    getMonthData(moduleName) {
      const currentDate = moment();
      const monthStart = currentDate.clone().startOf("month").format("YYYY-MM-DD");
      const monthEnd = currentDate.clone().endOf("month").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data_vencimento: [monthStart, monthEnd],
      };
    },
    getMonthDataFinanceiro(moduleName) {
      const currentDate = moment();
      const monthStart = currentDate.clone().startOf("month").format("YYYY-MM-DD");
      const monthEnd = currentDate.clone().endOf("month").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data: [monthStart, monthEnd],
      };
    },
    getLastWeekData(moduleName) {
      const currentDate = moment();
      const weekStart = currentDate.clone().subtract("days", 7).startOf("isoWeek").format("YYYY-MM-DD");
      const weekEnd = currentDate.clone().subtract("days", 7).endOf("isoWeek").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data_vencimento: [weekStart, weekEnd],
      };
    },
    getLastWeekDataFiananceiro(moduleName) {
      const currentDate = moment();
      const weekStart = currentDate.clone().subtract("days", 7).startOf("isoWeek").format("YYYY-MM-DD");
      const weekEnd = currentDate.clone().subtract("days", 7).endOf("isoWeek").format("YYYY-MM-DD");

      filtersStore[moduleName].filters = {
        ...filtersStore[moduleName].filters,
        range_data: [weekStart, weekEnd],
      };
    },
    removeLoadingToButton(ref) {
      const submitButton = this.$refs[ref];

      submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
      submitButton.removeAttribute("disabled", "");
    },
    thisHours() {
      return moment().format("HH:mm:ss");
    },
    formatCpfCnpj(valor) {
      if (valor === null) {
        return "";
      }
      if (valor.length <= 11) {
        // eslint-disable-next-line
        return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, `\$1.\$2.\$3\-\$4`);
      }
      // eslint-disable-next-line
      return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
    },
    defineParcelas(parcelas, valor, vencimento) {
      const pagamento = [];
      for (let i = 0; i < parcelas; i++) {
        let vencimentoDate = new Date(vencimento);
        vencimentoDate.setMonth(vencimentoDate.getMonth() + i + 1);
        vencimentoDate.setDate(vencimentoDate.getDate() + 1);
        pagamento.push({
          valor,
          data_vencimento: moment(vencimentoDate).format("YYYY-MM-DD"),
        });
      }
      return pagamento;
    },
    formatNumberToFloat(numberString) {
      if (typeof numberString === "number") return numberString;

      const partes = numberString.split(/[,.]/);
      let decimalExtension = 0;
      if (partes.length > 1) {
        const casasDecimais = partes[partes.length - 1];
        decimalExtension = casasDecimais.length;
      }

      const valorNumerico = parseFloat(numberString.replaceAll(",", "").replaceAll(".", ""));

      const valueFormatted = valorNumerico / 10 ** decimalExtension;

      return valueFormatted;
    },
    formatDataToSendToApi(
      formNatureza,
      formProduto,
      formCliente,
      formFaturamento,
      formImpostos,
      formIntermediador,
      formTransportador,
      formRural
    ) {
      const arredondarValor = (valor) => Number((Number(valor) || 0).toFixed(2));
      const normalizarRange = (range = []) =>
        range.map((parcela) => ({
          ...parcela,
          value: arredondarValor(parcela.value),
        }));
      const formImpostosNormalizado = {
        ...formImpostos,
        totalNFE: arredondarValor(formImpostos.totalNFE),
        discount: arredondarValor(formImpostos.discount),
      };

      const enderecoPrincipal = (formTransportador?.enderecos || []).find(
        (endereco) => !!endereco?.id_pessoa_endereco
      );

      const address = {
        id_pessoa_endereco: enderecoPrincipal?.id_pessoa_endereco ?? null,
        cep: enderecoPrincipal?.cep ?? null,
        street: enderecoPrincipal?.logradouro ?? null,
        number: enderecoPrincipal?.numero ?? null,
        complement: enderecoPrincipal?.complement ?? null,
        neighbourhood: enderecoPrincipal?.bairro ?? null,
        id_pessoa: enderecoPrincipal?.id_pessoa ?? null,
        id_cidade: enderecoPrincipal?.id_cidade ?? null,
        id_tipo: enderecoPrincipal?.id_tipo ?? null,
      };

      const data = {
        modelo: 55,
        generationDate: formNatureza.dataEmissao,
        freightType: formTransportador
          ? formTransportador.frete
          : {
            codigo: 9,
            descricao: "Sem Ocorrrência de Transporte",
          },
        ...(store.orcamentos.length > 0 && {
          orcamentos: store.orcamentos,
        }),
        ...(store.pedidos.length > 0 && {
          pedidos: store.pedidos,
        }),
        ...(store.os.length > 0 && {
          os: store.os,
        }),
        ...formImpostosNormalizado,
        ...(store.devolucaoCreditoItens.length > 0 && {
          devolucao_credito_itens_ids: store.devolucaoCreditoItens.map(
            (item) => item.id
          ),
        }),
        ...formImpostos,
        freightPrice: formImpostos.freightPrice,
        insurance: formImpostos.insurance,
        extraValue: formImpostos.extraValue,
        rateio_desconto: formImpostos.rateio_desconto ?? false,
        price: 0,
        discountIsPercentage: false,
        tpNF: 1, // manter 1
        keyDevolution: formNatureza?.keyDevolution ?? "",
        ...(!!formCliente.local_embarque && {
          exporta: {
            local_embarque: formCliente.local_embarque,
            uf_embarque: formCliente.uf_embarque,
            local_despacho: formCliente.local_despacho,
          },
        }),
        ...(!!formIntermediador && {
          tipoIntermediador: formIntermediador.id,
          intermediador: { ...formIntermediador },
          usuarioIntermediador: formIntermediador.indicador.id === 0 ? "" : formIntermediador.usuario,
        }),
        defaultValues: true, // deixar como true sempre
        remainingPrice: 0, // Deixar zerado
        // discount: 0, ///desconto total nota no impostoData
        natureza: formNatureza.natureza,
        ...(!!formNatureza.vendedor && {
          vendedor: {
            id_vendedor: formNatureza.vendedor.id_vendedor,
            nome: formNatureza.vendedor.nome,
          },
        }),
        serie: formNatureza.serie,
        ...(!!formCliente.cnpj_cpf && {
          buyer: {
            id_pessoa: formCliente.id_pessoa,
            cnpj_cpf: formCliente.cnpj_cpf,
            rg: formCliente.ie_rg,
            suframaCode: formCliente.codigo,
            nome: formCliente.nome,
            indicadorIE: formCliente.identificador_ie ?? 9,
            produtor_rural: formCliente.produtor_rural,
            estrangeiro: formCliente.estrangeiro,
          },
          shippingInfo: {
            address: {
              id_pessoa_endereco: formCliente.endereco.id_pessoa_endereco,
              cep: formCliente.endereco.cep,
              street: formCliente.endereco.logradouro,
              number: formCliente.endereco.numero,
              complement: formCliente.endereco.complemento,
              neighbourhood: formCliente.endereco.bairro,
              id_pessoa: formCliente.endereco.id_pessoa,
              id_cidade: formCliente.endereco.id_cidade,
              id_tipo: formCliente.endereco.id_tipo,
            },
            fone: formCliente.fone,
            email: formCliente.email,
            contactPerson: formCliente.contato,
          },
        }),

        ...(!!formCliente.enderecoEntrega && {
          enderecoEntrega: formCliente.enderecoEntrega
        }),

        ...(!!formCliente.tributacao_revenda && {
          tributacao_revenda: formCliente.tributacao_revenda
        }),

        rural: formRural ?? {},
        productOfTradeCollection: formProduto.produtos,

        ...(!!formTransportador?.cnpj_cpf && {
          deliveryInfo: {
            delivery: {
              ...formTransportador,
              name: formTransportador?.nome ?? null,
            },
            address,
            veiculo: {
              ...(formTransportador?.veiculo && { ...formTransportador?.veiculo }),
            },
          },
        }),
        ...(!!formTransportador && {
          volume: {
            quantity: formTransportador?.quantidade ?? null,
            species: formTransportador?.especie ?? null,
            brand: formTransportador?.marca ?? null,
            numeration: formTransportador?.numeracao ?? null,
            grossWeight: formTransportador?.pesoBruto ?? null,
            netWeight: formTransportador?.pesoLiquido ?? null,
          },
        }),
        ...(!!formFaturamento && {
          observation: formFaturamento.informacoes_adicionais,
          id_plano_contas: formFaturamento.pagamentos[0]?.plano_conta?.id ?? 2,
          paymentModeCollection: formFaturamento.pagamentos.map((pagamento) => {
            let vezes = 1;
            if (
              pagamento.forma_pagamento.descricao.includes("A prazo") ||
              pagamento.forma_pagamento.descricao.includes("Cartão de crédito") ||
              pagamento.forma_pagamento.descricao.includes("Cartão de débito")
            ) {
              vezes = this.getParcelas(pagamento.forma_pagamento.descricao);
            }
            return pagamento.forma_pagamento.descricao !== "Nenhum"
              ? {
                id: pagamento.forma_pagamento.id,
                descricao: pagamento.forma_pagamento.descricao,
                id_meio_pagamento: pagamento.forma_pagamento.id_meio_pagamento,
                vezes,
                requer_entrada: pagamento.forma_pagamento.requer_entrada,
                deleted_at: null,
                created_at: pagamento.forma_pagamento.createdAt,
                updated_at: pagamento.forma_pagamento.updatedAt,
                value: arredondarValor(pagamento.valor),
                paymentMode: {
                  description: pagamento.forma_pagamento.descricao,
                  id: pagamento.forma_pagamento.id_meio_pagamento,
                  name: pagamento.forma_pagamento.descricao,
                },
                range: normalizarRange(pagamento.range),
              }
              : {
                id: pagamento.forma_pagamento.id,
                descricao: pagamento.forma_pagamento.descricao,
                id_meio_pagamento: pagamento.forma_pagamento.id_meio_pagamento,
                vezes,
                requer_entrada: pagamento.forma_pagamento.requer_entrada,
                deleted_at: null,
                created_at: pagamento.forma_pagamento.createdAt,
                updated_at: pagamento.forma_pagamento.updatedAt,
                value: 0,
                paymentMode: {
                  description: pagamento.forma_pagamento.descricao,
                  id: pagamento.forma_pagamento.id_meio_pagamento,
                  name: pagamento.forma_pagamento.descricao,
                },
                range: [
                  {
                    value: 0,
                    date: this.thisDate(),
                  },
                ],
              };
          }),
        }),

        finNFe: formNatureza.finalidade.codigo ?? formNatureza.finalidade.id, // codigo da finalidade da natureza

        outputDateTime: formNatureza.dataSaida
          ? formNatureza.dataSaida + (formNatureza.horaSaida ? " " + formNatureza.horaSaida : "")
          : null, // data de saida (natureza)
      };

      return data;
    },
    extractOSByNFSeDataFromImport(data) {
      const formTomador = data?.cliente?.cnpj_cpf
        ? {
          ...data.cliente,
          endereco: data.endereco,
        }
        : null;

      const formServicos = data.servicos ? [...data.servicos] : null;

      const pagamentos = this.resolvePaymentsToImport(
        data.pagamentos ?? data.parcelas ?? [],
        data?.os?.length ?? 1
      );
      const formPagamento = pagamentos
        ? {
          pagamentos: pagamentos.map((pagamento) => ({
            forma_pagamento: {
              id: pagamento.id,
              descricao: pagamento.descricao,
              id_meio_pagamento: pagamento.id_meio_pagamento,
              vezes: pagamento.vezes ?? 1,
              requer_entrada: pagamento.requer_entrada ?? false,
              value: parseFloat(pagamento.value) || 0,
            },
            informacoes_adicionais: data?.informacoes_complementares ?? '',
            range: pagamento.range ?? [],
            valor: parseFloat(pagamento.value) || 0,
            vencimento: pagamento.range?.[0]?.date ?? null,
          })),
        }
        : null;

      const informacoesComplementares = data?.informacoes_complementares;

      return [formServicos, formTomador, formPagamento, informacoesComplementares];
    },
    normalizePaymentToImport(payment) {
      const formaPagamento = payment?.forma_pagamento ?? {};
      const descricao = payment?.descricao ?? formaPagamento?.descricao ?? "";
      const value = parseFloat(payment?.value ?? payment?.valor) || 0;
      const idMeioPagamento =
        payment?.id_meio_pagamento ?? formaPagamento?.id_meio_pagamento ?? null;

      return {
        ...payment,
        id: payment?.id ?? formaPagamento?.id ?? null,
        descricao,
        id_meio_pagamento: idMeioPagamento,
        vezes: payment?.vezes ?? formaPagamento?.vezes ?? 1,
        requer_entrada:
          payment?.requer_entrada ?? formaPagamento?.requer_entrada ?? false,
        value,
        paymentMode: payment?.paymentMode ?? {
          description: descricao,
          id: idMeioPagamento,
          name: descricao,
        },
        range: payment?.range ?? [
          {
            value,
            date:
              payment?.vencimento ?? new Date().toISOString().substring(0, 10),
          },
        ],
      };
    },
    normalizePaymentsToImport(rawPayments) {
      return (rawPayments ?? []).map((payment) =>
        this.normalizePaymentToImport(payment)
      );
    },
    hasImportablePayments(rawPayments) {
      return this.normalizePaymentsToImport(rawPayments).some(
        (pm) => pm.descricao !== "Nenhum" && pm.descricao?.trim() !== "Nenhum"
      );
    },
    // Aplica as regras de negócio para importação de pagamentos:
    // - 1 item importado: sempre traz o pagamento como está, sem regras
    // - 2+ itens: se todos "À vista" → soma em 1; qualquer outro → null (manual)
    resolvePaymentsToImport(rawPayments, pedidosCount) {
      const count = pedidosCount != null ? pedidosCount : 1;
      const payments = this.normalizePaymentsToImport(rawPayments).filter(
        (pm) => pm.descricao !== "Nenhum" && pm.descricao?.trim() !== "Nenhum"
      );
      if (payments.length === 0) return null;

      // 1 item importado: sempre retorna os pagamentos como vieram
      if (count <= 1) return payments;

      // 2+ itens: regras se aplicam
      const isAVista = (pm) => {
        const d = (pm?.descricao ?? '').trim().toLowerCase();
        return d === 'à vista' || d === 'a vista';
      };
      const allAVista = payments.every(isAVista);
      if (!allAVista) return null;

      const totalValue = payments.reduce(
        (sum, pm) => sum + (parseFloat(pm.value) || 0),
        0
      );
      return [
        {
          ...payments[0],
          value: totalValue,
          range: [
            {
              value: totalValue,
              date:
                payments[0].range?.[0]?.date ??
                new Date().toISOString().substring(0, 10),
            },
          ],
        },
      ];
    },
    extractDataFromImport(data, pedidosCount) {
      const pm0 = data.paymentModeCollection?.[0];

      const formFaturamento = pm0
        ? {
          pagamentos: [
            {
              forma_pagamento: {
                id: pm0.id,
                descricao: pm0.descricao,
                id_meio_pagamento: pm0.id_meio_pagamento,
                vezes: pm0.vezes ?? 1,
                requer_entrada: pm0.requer_entrada,
                value: parseFloat(pm0.value) || 0,
              },
              informacoes_adicionais: data.observation ?? '',
              range: pm0.range ?? [],
              valor: parseFloat(pm0.value) || 0,
              vencimento: pm0.range?.[0]?.date ?? null,
            },
          ],
        }
        : null;
      const formCliente = data?.buyer?.cnpj_cpf
        ? {
          ...data.buyer,
          fone: data.buyer?.fones[0],
          email: data.buyer?.emails[0],
          endereco: data.buyer?.enderecos[0],
          contactPerson: data.shippingInfo?.contactPerson,
        }
        : null;

      const formProduto = {
        produtos: data.productOfTradeCollection.map((produto) => ({ ...produto })),
        subtotal: data.productOfTradeCollection.reduce(
          (acc, product) => acc + (product.price * product.quantity - (product.discount ?? 0)),
          0
        ),
      };

      formProduto.produtos.forEach((produto, index) => {
        formProduto.produtos[index].currentIndex = index;
      });
      const formTransportador = {
        deliveryInfo: data?.deliveryInfo,
        volume: data?.volume,
        freightType: data?.freightType,
      };

      return [formFaturamento, formProduto, formCliente, formTransportador];
    },
    formatDataToSendToOrcamentoApi(cliente, formProdutos, pagamentos, informacoes, transportador) {
      const arredondarValor = (valor) => Number((Number(valor) || 0).toFixed(2));
      const normalizarRange = (range = []) =>
        range.map((parcela) => ({
          ...parcela,
          value: arredondarValor(parcela.value),
        }));
      let frete = 0;

      if (pagamentos.frete) {
        frete = arredondarValor(pagamentos.frete);
      }
      const desconto = arredondarValor(pagamentos.desconto);
      const valorTotal = arredondarValor(formProdutos.subtotal - desconto + frete);

      const data = {
        status: informacoes.status.id,
        cliente: {
          id_pessoa: cliente.id_pessoa,
        },
        pedido_compra: informacoes.pedido_compra ?? null,
        solicitante: cliente.solicitante ?? null,
        vendedor: cliente.vendedor ?? null,
        dataValidade: informacoes.validade,
        observacao: informacoes.observacao,
        produtos: formProdutos.produtos,
        pagamentos: pagamentos.pagamentos.map((pagamento) => {
          let vezes = 1;
          if (
            pagamento.forma_pagamento.descricao.includes("A prazo") ||
            pagamento.forma_pagamento.descricao.includes("Cartão de crédito") ||
            pagamento.forma_pagamento.descricao.includes("Cartão de débito")
          ) {
            vezes = this.getParcelas(pagamento.forma_pagamento.descricao);
          }
          return {
            id: pagamento.forma_pagamento.id,
            descricao: pagamento.forma_pagamento.descricao,
            id_meio_pagamento: pagamento.forma_pagamento.id_meio_pagamento,
            vezes,
            requer_entrada: pagamento.forma_pagamento.requer_entrada,
            deleted_at: null,
            created_at: pagamento.forma_pagamento.createdAt,
            updated_at: pagamento.forma_pagamento.updatedAt,
            value: arredondarValor(pagamento.valor),
            paymentMode: {
              description: pagamento.forma_pagamento.descricao,
              id: pagamento.forma_pagamento.id_meio_pagamento,
              name: pagamento.forma_pagamento.descricao,
            },
            range: normalizarRange(pagamento.range),
          };
        }),
        valorTotal,
        descontoPorcentage: false,
        desconto,
        frete: frete,
        ...(!!transportador?.nome && {
          transportador: {
            deliveryInfo: {
              delivery: {
                ...transportador,
                name: transportador?.nome ?? null,
              },
              addresses: (transportador?.enderecos || []).map((endereco) => ({
                id_pessoa_endereco: endereco?.id_pessoa_endereco ?? null,
                cep: endereco?.cep ?? null,
                street: endereco?.logradouro ?? null,
                number: endereco?.numero ?? null,
                complement: endereco?.complement ?? null,
                neighbourhood: endereco?.bairro ?? null,
                id_pessoa: endereco?.id_pessoa ?? null,
                id_cidade: endereco?.id_cidade ?? null,
                id_tipo: endereco?.id_tipo ?? null,
              })),
              veiculo: {
                ...(transportador?.veiculo && { ...transportador?.veiculo }),
              },
            },
            volume: {
              quantity: transportador?.quantidade ?? null,
              species: transportador?.especie ?? null,
              brand: transportador?.marca ?? null,
              numeration: transportador?.numeracao ?? null,
              grossWeight: transportador?.pesoBruto ?? null,
              netWeight: transportador?.pesoLiquido ?? null,
            },
          },
        }),
        pesoBruto: informacoes?.pesoBruto ?? 0,
        pesoLiquido: informacoes?.pesoLiquido ?? 0,
        data_solicitacao: informacoes.data_solicitacao ?? null,
      };

      return data;
    },

    formatDataToSendToContratoApi(cliente, formServicos, formPagamentos, informacoes) {
      const data = {
        status: informacoes.status.id,
        id_pessoa: cliente.id_pessoa,
        data_inicio: informacoes.data_inicio,
        data_termino: informacoes.data_termino,
        email_fatura: informacoes.email_fatura,
        emitir_nfse: informacoes.emitir_nfse,
        emitir_boletos: informacoes.emitir_boletos,
        renovacao_automatica: informacoes.renovacao_automatica,
        termino_recorrencia: informacoes.termino_recorrencia,
        dia_cobranca: formPagamentos.dia_cobranca,
        taxa_implantacao: formPagamentos.taxa_implantacao,
        id_plano_contas: formPagamentos.plano_conta?.id ?? null,
        cobranca_anual: formPagamentos.cobranca_anual,
        considerar_taxa: formPagamentos.considerar_taxa,
        data_boleto_taxa: formPagamentos.data_boleto_taxa,
        observacao: informacoes.observacao,
        id_vendedor: informacoes.id_vendedor,
        servicos: formServicos,
        pagamentos: formPagamentos.pagamentos ?? null,
        gerar_boleto_taxa: formPagamentos.gerar_boleto_taxa ?? false,
        data_venda: informacoes.data_venda ?? null,
        pular_final_semana: formPagamentos.pular_final_semana ?? false,
        valor_total:
          formServicos.reduce((acc, servico) => acc + Number(servico.total || 0), 0) +
          Number(formPagamentos.taxa_implantacao || 0) +
          Number(formPagamentos.valor_tef || 0) * (formPagamentos.plugin_tef ? 1 : 0) +
          Number(formPagamentos.valor_certificado || 0) * (formPagamentos.plugin_certificado ? 1 : 0),
        plugin_tef: formPagamentos.plugin_tef ?? false,
        plugin_certificado: formPagamentos.plugin_certificado ?? false,
        valor_tef: formPagamentos.valor_tef ?? 0,
        valor_certificado: formPagamentos.valor_certificado ?? 0,
      };

      return data;
    },

    formatDataToSendToOrdemApi(fornecedor, formProdutos, pagamentos, informacoes) {
      const data = {
        status: informacoes.status.id,
        fornecedor: {
          id_pessoa: fornecedor.id_pessoa,
        },
        data_solicitacao: informacoes.data_solicitacao,
        observacao: informacoes.observacao,
        produtos: formProdutos.produtos,
        pagamentos: pagamentos.pagamentos.map((pagamento) => {
          let vezes = 1;
          if (
            pagamento.forma_pagamento.descricao.includes("A prazo") ||
            pagamento.forma_pagamento.descricao.includes("Cartão de crédito") ||
            pagamento.forma_pagamento.descricao.includes("Cartão de débito")
          ) {
            vezes = this.getParcelas(pagamento.forma_pagamento.descricao);
          }
          return {
            id: pagamento.forma_pagamento.id,
            descricao: pagamento.forma_pagamento.descricao,
            id_meio_pagamento: pagamento.forma_pagamento.id_meio_pagamento,
            vezes,
            requer_entrada: pagamento.forma_pagamento.requer_entrada,
            created_at: pagamento.forma_pagamento.createdAt,
            updated_at: pagamento.forma_pagamento.updatedAt,
            value: pagamento.valor,
            paymentMode: {
              description: pagamento.forma_pagamento.descricao,
              id: pagamento.forma_pagamento.id_meio_pagamento,
              name: pagamento.forma_pagamento.descricao,
            },
            range: pagamento.range,
          };
        }),
        valorTotal: formProdutos.subtotal,
      };

      return data;
    },

    formatDataToSendToOSApi() {
      const arredondarValor = (valor) => Number((Number(valor) || 0).toFixed(2));
      const normalizarPagamentos = (pagamentos = []) =>
        pagamentos.map((pagamento) => ({
          ...pagamento,
          valor: arredondarValor(pagamento.valor),
          range: (pagamento.range || []).map((parcela) => ({
            ...parcela,
            value: arredondarValor(parcela.value),
          })),
        }));
      let data = new FormData();
      const totalServicos =
        JSON.stringify(OSStore.formServicos) !== "{}" && OSStore.formServicos !== null
          ? OSStore.formServicos.reduce((acc, servico) => acc + servico.total, 0)
          : 0;

      const totalProdutos = OSStore.formProduto?.subtotal ?? 0;
      if (!!OSStore.formAnexos.anexo_1 && typeof OSStore.formAnexos.anexo_1 !== "string") {
        data.append("anexo_1", OSStore.formAnexos.anexo_1);
      }
      if (!!OSStore.formAnexos.anexo_2 && typeof OSStore.formAnexos.anexo_2 !== "string") {
        data.append("anexo_2", OSStore.formAnexos.anexo_2);
      }
      if (!!OSStore.formAnexos.anexo_3 && typeof OSStore.formAnexos.anexo_3 !== "string") {
        data.append("anexo_3", OSStore.formAnexos.anexo_3);
      }
      if (!!OSStore.formAnexos.anexo_4 && typeof OSStore.formAnexos.anexo_4 !== "string") {
        data.append("anexo_4", OSStore.formAnexos.anexo_4);
      }
      if (!!OSStore.formAnexos.anexo_5 && typeof OSStore.formAnexos.anexo_5 !== "string") {
        data.append("anexo_5", OSStore.formAnexos.anexo_5);
      }
      if (!!OSStore.formAnexos.anexo_6 && typeof OSStore.formAnexos.anexo_6 !== "string") {
        data.append("anexo_6", OSStore.formAnexos.anexo_6);
      }
      if (OSStore.formAnexos.remover_anexos?.length) {
        data.append(
          "remover_anexos",
          JSON.stringify(OSStore.formAnexos.remover_anexos)
        );
      }
      if (!!OSStore.formGerais.cliente.id_pessoa) {
        data.append("id_pessoa", OSStore.formGerais.cliente.id_pessoa);
      }
      if (!!OSStore.formGerais.cliente.endereco) {
        data.append("endereco", JSON.stringify(OSStore.formGerais.cliente.endereco));
      }
      if (!!OSStore.formGerais.tecnico) {
        if (!!OSStore.formGerais.tecnico.id_tecnico) {
          data.append("id_tecnico", OSStore.formGerais.tecnico.id_tecnico);
        }
      }
      if (!!OSStore.formObjeto.objeto.id_objeto) {
        data.append("id_objeto", OSStore.formObjeto.objeto.id_objeto);
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.dataEntrada) {
          data.append("dataEntrada", OSStore.formGerais.dataEntrada);
        } else {
          data.append("dataEntrada", "");
        }
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.dataPrevisao) {
          data.append("dataPrevisao", OSStore.formGerais.dataPrevisao);
        } else {
          data.append("dataPrevisao", "");
        }
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.dataConclusao) {
          data.append("dataConclusao", OSStore.formGerais.dataConclusao);
        } else {
          data.append("dataConclusao", "");
        }
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.garantia) {
          data.append("garantia", OSStore.formGerais.garantia);
        }
        if (!OSStore.formGerais.garantia) {
          data.append("garantia", "");
        }
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.local_atendimento) {
          data.append("local_atendimento", OSStore.formGerais.local_atendimento);
        }
        if (!OSStore.formGerais.local_atendimento) {
          data.append("local_atendimento", "");
        }
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.numero_interno) {
          data.append("numero_interno", OSStore.formGerais.numero_interno);
        }
        if (!OSStore.formGerais.numero_interno) {
          data.append("numero_interno", "");
        }
      }
      if (!!OSStore.formProblema) {
        if (OSStore.formProblema.problema) {
          data.append("problema", OSStore.formProblema.problema);
        }
        if (!OSStore.formProblema.problema) {
          data.append("problema", "");
        }
      }
      if (!!OSStore.formProblema) {
        if (OSStore.formProblema.horarios) {
          data.append("horarios", JSON.stringify(OSStore.formProblema.horarios));
        }
      }
      if (!!OSStore.formObservacoes) {
        if (OSStore.formObservacoes.observacaoInterna) {
          data.append("observacaoInterna", OSStore.formObservacoes.observacaoInterna);
        }
        if (!OSStore.formObservacoes.observacaoInterna) {
          data.append("observacaoInterna", "");
        }
      }
      if (!!OSStore.formObservacoes) {
        if (OSStore.formObservacoes.observacao) {
          data.append("observacao", OSStore.formObservacoes.observacao);
        }
        if (!OSStore.formObservacoes.observacao) {
          data.append("observacao", "");
        }
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.dataSaida) {
          data.append("dataSaida", OSStore.formGerais.dataSaida);
        } else {
          data.append("dataSaida", "");
        }
      }
      if (!!OSStore.formGerais) {
        if (OSStore.formGerais.proxRevisao) {
          data.append("proximaRevisao", OSStore.formGerais.proxRevisao);
        } else {
          data.append("proximaRevisao", "");
        }
      }
      const desconto = arredondarValor(OSStore.formPagamentos.desconto);
      const valorTotal = arredondarValor(totalProdutos + totalServicos - desconto);
      data.append("valorTotal", valorTotal);
      if (OSStore.formProduto?.produtos?.length !== undefined) {
        data.append("produtos", JSON.stringify(OSStore.formProduto.produtos));
      }
      if (JSON.stringify(OSStore.formServicos) !== "{}") {
        data.append("servicos", JSON.stringify(OSStore.formServicos));
      }
      data.append("identificadores", JSON.stringify(OSStore.formObjeto.identificadores ?? []));
      data.append("pagamentos", JSON.stringify(normalizarPagamentos(OSStore.formPagamentos.pagamentos)));
      data.append("desconto", desconto);

      if (!!OSStore.formGerais.horaAgendamento) {
        data.append("horaAgendamento", OSStore.formGerais.horaAgendamento);
      }

      if (!!OSStore.formGerais.solicitante) {
        data.append("solicitante", OSStore.formGerais.solicitante);
      }

      return data;
    },
    formatDataToSendToSimplificadaApi() {
      let valor = SimplificadaStore.formPagamentos.valor;

      if (typeof valor === 'object' && valor !== null) {
        valor = 0;
      }

      const data = {
        descricao: SimplificadaStore.formGerais.descricao,
        cliente: SimplificadaStore.formGerais.cliente ?? null,
        data_manutencao: SimplificadaStore.formGerais.data_manutencao,
        tecnico: SimplificadaStore.formGerais.tecnico ?? null,
        objeto: SimplificadaStore.formGerais.objeto ?? null,
        servicos: SimplificadaStore.formServicos ?? null,
        pagamentos: SimplificadaStore.formPagamentos ?? null,
        valor: valor ?? 0,
        observacao: SimplificadaStore.formObservacoes.observacao ?? null,
      }

      return data;
    },
  },
  toCamelCase(string) {
    return string
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  },
};
